'use client'

import { useSearchStore } from '@stores/search.store'

import Image from 'next/image'

import { JobDescription } from '@types'

import useSearchDispatcher from '@hooks/useSearchDispatcher'
import { noop } from '@lib/helpers/client'

import SearchIcon from '@images/searchbox/icon_field-search_index.png'

import styles from './research.module.scss'

import { JobTypeAhead } from '../typeahead'

export default function JobSearch(): JSX.Element {
  const searchDispatcher = useSearchDispatcher()
  const nextSearch = useSearchStore((state) => state.nextSearch)

  function onOpenSearch(job: JobDescription): void {
    searchDispatcher({ job })
  }

  return (
    <div className={styles.wrap}>
      <div className={styles['input-container']}>
        <JobTypeAhead
          currentJob={nextSearch.job}
          research
          setJob={onOpenSearch}
          setShowError={noop}
          showError={false}
        />
        <Image className={styles.img} src={SearchIcon} alt="Search Icon" height={60} width={78} />
      </div>
    </div>
  )
}
